import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResumeModule } from 'libraries/component/resume/resume.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { SearchHotelFormModule } from 'libraries/hotel/containers/search-hotel-form/search-hotel-form.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { HotelListModule } from 'libraries/hotel/containers/hotels-list/hotel-list.module';
import { SearchComponent } from './search.component';
import { ConfigSharedHotelResolver } from 'libraries/hotel/resolvers/config-shared-hotel.resolver';
import { ConfigSharedHotelModule } from "libraries/service/resources/configuration/config-shared-hotel.module";
import { FieldDescriptionModule } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module";
import { ClickOutsideModule } from "libraries/ui_clickOutside/clickOutside.module";

@NgModule({
    imports: [
        BtnModule,
        ButtonModule,
        CardModule,
        ClickOutsideModule,
        CommonModule,
        ConfigSharedHotelModule,
        FieldDescriptionModule,
        HotelListModule,
        NotificationModule,
        ResumeModule,
        SearchHotelFormModule,
    ],
    declarations: [
        SearchComponent,
    ],
    exports: [
        SearchComponent,
    ],
    providers: [
        ConfigSharedHotelResolver
    ]
})
export class SearchModule {  }